import { z } from "zod";

export const DisciplinaRequestSchema = z.object({
  idDisciplina: z.number().nullable().optional(),
  idProjeto: z.number().nullable().optional(),
  idChecklist: z.number().nullable().optional(),

  tipo: z.string().nullable().optional(),
  descricao: z.string().trim().min(1, "A descrição é obrigatória"),

  idFuncionario: z.number().nullable().optional(),
  idFornecedor: z.number().nullable().optional(),
  idCliente: z.number().nullable().optional(),
  descResponsavel: z.string().nullable().optional(),

  datainicioPrevisto: z.coerce.date().nullable().optional(),
  datainicioReal: z.coerce.date().nullable().optional(),
  datafimPrevisto: z.coerce.date().nullable().optional(),
  datafimReal: z.coerce.date().nullable().optional(),
  dataDisciplina: z.coerce.date().nullable().optional(),

  revisao: z.string().nullable().optional(),
  plantas: z.string().nullable().optional(),

  local1: z.string().nullable().optional(),
  local2: z.string().nullable().optional(),
  local3: z.string().nullable().optional(),
  local4: z.string().nullable().optional(),
  local5: z.string().nullable().optional(),
  local6: z.string().nullable().optional(),

  nCopia1: z.string().nullable().optional(),
  nCopia2: z.string().nullable().optional(),
  nCopia3: z.string().nullable().optional(),
  nCopia4: z.string().nullable().optional(),
  nCopia5: z.string().nullable().optional(),
  nCopia6: z.string().nullable().optional(),

  subdiciplina: z.boolean().nullable().optional(),
  idDisciplinaPai: z.number().nullable().optional(),
  ultimaRevisao: z.boolean().nullable().optional(),

  idUsuario: z.number().nullable().optional(),
});

export type DisciplinaRequestForm = z.infer<typeof DisciplinaRequestSchema>;
